module.exports = __webpack_public_path__ + "media/assets/images/info-475743e4a0ad4c55eab315e97374a093.svg";